import { FC } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { MainLayout } from '@/components';
import { useAuthContext } from '@/providers';
import {
	AuthState,
	isModeratorPathAllowed,
	isNeighborhoodModerator,
	moderatorHomePath
} from '@/providers/auth';
import { IRouteProps } from '../types';

export const AdminRoute: FC<IRouteProps> = ({ redirectPath }) => {
	const { user, authState } = useAuthContext();
	const location = useLocation();
	if (authState === AuthState.Loading) return null;
	// Moderatorul de cartier nu are acces decât la pagina cartierului lui (și la conținutul
	// pentru care are drept) — orice altă adresă, inclusiv una salvată, îl întoarce acolo.
	if (isNeighborhoodModerator(user) && !isModeratorPathAllowed(user, location.pathname))
		return <Navigate to={moderatorHomePath(user)} replace />;
	if (user?.role !== undefined)
		return (
			<MainLayout>
				<Outlet />
			</MainLayout>
		);

	return <Navigate to={redirectPath} replace />;
};
